import axios from './axios';

const SlidesApi = {
    getByLocale: (locale) => axios.get(`/slides/${locale}`),
    create: (formData) =>
        axios.post('/slides', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    update: (id, data) => axios.put(`/slides/${id}`, data),
    remove: (id) => axios.delete(`/slides/${id}`),
};

export default SlidesApi;
